export enum LocalStorageKey {
  SharedGame = 'shared-game',
  TeamInvitationAccept = 'team-invitation-accept',
  ReassignGame = 'reassign-game',
  SelectedLocation = 'selected-location',
  SelectedDistance = 'selected-distance',
  AlertsLocation = 'alerts-location',
  DashboardDismissedUpdateVersion = 'dashboard-dismissed-update-version'
}
